import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('mobile')]: {
      height: 'unset',
    },
  },
  paper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    [theme.breakpoints.up('mobile')]: {
      margin: [theme.spacing(8), theme.spacing(3)],
      padding: theme.spacing(8),
      border: [1, 'solid', theme.palette.colors.border],
      maxWidth: 1280,
      minWidth: 800,
      justifyContent: 'unset',
    },
  },
  headerText: {
    fontSize: 32,
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  button: {
    marginTop: theme.spacing(8),
    '&:hover': {
      color: theme.palette.colors.white,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/WelcomePage/useStyles.js